import {memo} from "react";
import {css} from "@panda/css";

import {ChevronLeftIcon, ChevronRightIcon} from "@pg-design/icons-module";
import {useIsPrint} from "@pg-mono/hooks";
import {rpAppLink} from "@pg-mono/rp-routes";
import {useUserDevice} from "@pg-mono/user-device";
import {NAV_MOBILE_BREAKPOINT, Navigation as DesignNavigation} from "@pg-rp/navigation";

import {BRAND_NAME} from "../../app/constants/company";
import {kmUrl} from "../../app/read_rp_environment_variables";
import {useRedirectedAuth} from "../../auth/hooks/use_redirected_auth";
import {useKMLinkDecorator} from "../../hooks/use_km_link";
import {useAppSelector} from "../../store/hooks";
import {gtmEventNavigationClick} from "../../tracking/google_tag_manager/gtm_event_navigation";
import {useGetUserProfileQuery} from "../../user/api/get_user_profile";
import {useIsAuthenticated} from "../../user/hooks/use_is_authenticated";
import {userDataModalDisplayStorage} from "../../user/utils/user_data_modal_display_storage";
import {ViewType} from "../../view_type/ViewType";
import {useNavigationSearch} from "../hooks/use_navigation_search";
import {trackAmplitudeNavigationClick} from "../tracking/track_amplitude_navigation_click";
import {OfferListNavigation} from "./OfferListNavigation";

const rpLogo = require("../../app/images/rp_logo.svg");

interface IProps {
    onPin?: () => void;
    onUnpin?: () => void;
    onUnfix?: () => void;
    blendTopOffset?: string;
}

export const Navigation = memo((props: IProps) => {
    const {isMobile} = useUserDevice();
    const isPrinting = useIsPrint();

    const viewTypeAbroad = ViewType.OFFER_LIST_ABROAD;
    const viewTypeOfferList = ViewType.OFFER_LIST;

    const backToUrl = useAppSelector((store) => store.backToUrl);
    const showOfferListNavigation = useAppSelector((state) => state.viewType.current === viewTypeOfferList || state.viewType.current === viewTypeAbroad);
    const isInvestmentListView = useAppSelector(
        (state) => state.viewType.current === ViewType.FOR_INVESTMENT_LIST || state.viewType.current === ViewType.FOR_INVESTMENT_LIST_MAP
    );
    const userPrefs = useAppSelector((state) => state.user.preferences?.data?.filters);

    const {onRedirectedLogin, onRedirectedLogout} = useRedirectedAuth();

    const onLogin = (e: React.MouseEvent<HTMLElement>) => {
        e.preventDefault();

        // Redirect user to Konto Mieszkaniowe login page
        onRedirectedLogin();
    };

    const onLogout = (e: React.MouseEvent<HTMLElement>) => {
        userDataModalDisplayStorage.resetUserModalDisplay();
        e.preventDefault();
        onRedirectedLogout();
    };

    const userPrefRegions = userPrefs?.region;
    const userPrefFilters =
        userPrefs?.price_0 ||
        userPrefs?.price_1 ||
        userPrefs?.area_0 ||
        userPrefs?.area_1 ||
        userPrefs?.rooms_0 ||
        userPrefs?.rooms_1 ||
        userPrefs?.construction_end_date ||
        userPrefs?.floor_choices;
    const allowRecommendationPopoverActivation = !!userPrefRegions && !!userPrefFilters;

    const isAuthenticated = useIsAuthenticated();
    const {data: userProfile} = useGetUserProfileQuery(undefined, {skip: !isAuthenticated});

    const navSearchElement = useNavigationSearch();
    const decorateKMLink = useKMLinkDecorator();

    return (
        <div className={navigationBackground}>
            <DesignNavigation
                navElementsConfig={{
                    kmUrl,
                    decorateKMLink,
                    onLogin,
                    onLogout,
                    isAuthenticated,
                    isMobile: !!isMobile,
                    allowPopoverActivation: allowRecommendationPopoverActivation,
                    userName: userProfile?.name,
                    gtmEventNavigationClick,
                    amplitudeNavClickTracking: ({selectedTab, sectionNumber, isUserNav}) => {
                        trackAmplitudeNavigationClick(isUserNav ? "rp_your_account" : "rp_menu_section", sectionNumber, selectedTab);
                    }
                }}
                navMiddleElement={navSearchElement}
                logo={logoData}
                arrows={navArrows}
                backToUrl={backToUrl}
                isMobile={!!isMobile}
                mobileBreakpoint={NAV_MOBILE_BREAKPOINT}
                isPrinting={isPrinting}
                onPin={props.onPin}
                onUnpin={props.onUnpin}
                onUnfix={props.onUnfix}
                blendTopOffset={isMobile ? undefined : props.blendTopOffset}
                disableMobileHeadroom={showOfferListNavigation || isInvestmentListView}
            />

            {showOfferListNavigation && <OfferListNavigation />}
        </div>
    );
});

const navigationBackground = css({
    bg: "var(--colors-white)"
});

const navArrows = {
    left: <ChevronLeftIcon size="1.2" />,
    right: <ChevronRightIcon size="1.2" />
};

const logoData = {
    imgUrl: rpLogo,
    url: rpAppLink.base(),
    alt: `Logo portalu ${BRAND_NAME}`,
    title: `Logo portalu ${BRAND_NAME}`
};
import {memo} from "react";
import {css} from "@panda/css";

import {ChevronLeftIcon, ChevronRightIcon} from "@pg-design/icons-module";
import {useIsPrint} from "@pg-mono/hooks";
import {rpAppLink} from "@pg-mono/rp-routes";
import {useUserDevice} from "@pg-mono/user-device";
import {NAV_MOBILE_BREAKPOINT, Navigation as DesignNavigation} from "@pg-rp/navigation";

import {BRAND_NAME} from "../../app/constants/company";
import {kmUrl} from "../../app/read_rp_environment_variables";
import {useRedirectedAuth} from "../../auth/hooks/use_redirected_auth";
import {useKMLinkDecorator} from "../../hooks/use_km_link";
import {useAppSelector} from "../../store/hooks";
import {gtmEventNavigationClick} from "../../tracking/google_tag_manager/gtm_event_navigation";
import {useGetUserProfileQuery} from "../../user/api/get_user_profile";
import {useIsAuthenticated} from "../../user/hooks/use_is_authenticated";
import {userDataModalDisplayStorage} from "../../user/utils/user_data_modal_display_storage";
import {ViewType} from "../../view_type/ViewType";
import {useNavigationSearch} from "../hooks/use_navigation_search";
import {trackAmplitudeNavigationClick} from "../tracking/track_amplitude_navigation_click";
import {OfferListNavigation} from "./OfferListNavigation";

const rpLogo = require("../../app/images/rp_logo.svg");

interface IProps {
    onPin?: () => void;
    onUnpin?: () => void;
    onUnfix?: () => void;
    blendTopOffset?: string;
}

export const Navigation = memo((props: IProps) => {
    const {isMobile} = useUserDevice();
    const isPrinting = useIsPrint();

    const viewTypeAbroad = ViewType.OFFER_LIST_ABROAD;
    const viewTypeOfferList = ViewType.OFFER_LIST;

    const backToUrl = useAppSelector((store) => store.backToUrl);
    const showOfferListNavigation = useAppSelector((state) => state.viewType.current === viewTypeOfferList || state.viewType.current === viewTypeAbroad);
    const isInvestmentListView = useAppSelector(
        (state) => state.viewType.current === ViewType.FOR_INVESTMENT_LIST || state.viewType.current === ViewType.FOR_INVESTMENT_LIST_MAP
    );
    const userPrefs = useAppSelector((state) => state.user.preferences?.data?.filters);

    const {onRedirectedLogin, onRedirectedLogout} = useRedirectedAuth();

    const onLogin = (e: React.MouseEvent<HTMLElement>) => {
        e.preventDefault();

        // Redirect user to Konto Mieszkaniowe login page
        onRedirectedLogin();
    };

    const onLogout = (e: React.MouseEvent<HTMLElement>) => {
        userDataModalDisplayStorage.resetUserModalDisplay();
        e.preventDefault();
        onRedirectedLogout();
    };

    const userPrefRegions = userPrefs?.region;
    const userPrefFilters =
        userPrefs?.price_0 ||
        userPrefs?.price_1 ||
        userPrefs?.area_0 ||
        userPrefs?.area_1 ||
        userPrefs?.rooms_0 ||
        userPrefs?.rooms_1 ||
        userPrefs?.construction_end_date ||
        userPrefs?.floor_choices;
    const allowRecommendationPopoverActivation = !!userPrefRegions && !!userPrefFilters;

    const isAuthenticated = useIsAuthenticated();
    const {data: userProfile} = useGetUserProfileQuery(undefined, {skip: !isAuthenticated});

    const navSearchElement = useNavigationSearch();
    const decorateKMLink = useKMLinkDecorator();

    return (
        <div className={navigationBackground}>
            <DesignNavigation
                navElementsConfig={{
                    kmUrl,
                    decorateKMLink,
                    onLogin,
                    onLogout,
                    isAuthenticated,
                    isMobile: !!isMobile,
                    allowPopoverActivation: allowRecommendationPopoverActivation,
                    userName: userProfile?.name,
                    gtmEventNavigationClick,
                    amplitudeNavClickTracking: ({selectedTab, sectionNumber, isUserNav}) => {
                        trackAmplitudeNavigationClick(isUserNav ? "rp_your_account" : "rp_menu_section", sectionNumber, selectedTab);
                    }
                }}
                navMiddleElement={navSearchElement}
                logo={logoData}
                arrows={navArrows}
                backToUrl={backToUrl}
                isMobile={!!isMobile}
                mobileBreakpoint={NAV_MOBILE_BREAKPOINT}
                isPrinting={isPrinting}
                onPin={props.onPin}
                onUnpin={props.onUnpin}
                onUnfix={props.onUnfix}
                blendTopOffset={isMobile ? undefined : props.blendTopOffset}
                disableMobileHeadroom={showOfferListNavigation || isInvestmentListView}
            />

            {showOfferListNavigation && <OfferListNavigation />}
        </div>
    );
});

const navigationBackground = css({
    bg: "var(--colors-white)"
});

const navArrows = {
    left: <ChevronLeftIcon size="1.2" />,
    right: <ChevronRightIcon size="1.2" />
};

const logoData = {
    imgUrl: rpLogo,
    url: rpAppLink.base(),
    alt: `Logo portalu ${BRAND_NAME}`,
    title: `Logo portalu ${BRAND_NAME}`
};
